/**
 * @generated SignedSource<<31dcd00fa5a5e86310bcd987c5634779>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditViewWithIsEditable_fragmentRef$data = {
  readonly id: string;
  readonly issue: {
    readonly id: string;
  } | null | undefined;
  readonly name: string;
  readonly project: {
    readonly atlasProjectKey: string | null | undefined;
    readonly atlasProjectName: string | null | undefined;
    readonly id: string;
    readonly privateProject: boolean | null | undefined;
  } | null | undefined;
  readonly type: string;
  readonly " $fragmentSpreads": FragmentRefs<"atlasProject_issueFieldAtlasProjectReadviewFull_AtlasProjectReadView">;
  readonly " $fragmentType": "atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditViewWithIsEditable_fragmentRef";
};
export type atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditViewWithIsEditable_fragmentRef$key = {
  readonly " $data"?: atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditViewWithIsEditable_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditViewWithIsEditable_fragmentRef">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditViewWithIsEditable_fragmentRef",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "issue",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    },
    {
      "concreteType": "JiraTownsquareProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": "atlasProjectName",
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "alias": "atlasProjectKey",
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "kind": "ScalarField",
          "name": "privateProject"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "atlasProject_issueFieldAtlasProjectReadviewFull_AtlasProjectReadView"
    }
  ],
  "type": "JiraTownsquareProjectField"
};
})();

(node as any).hash = "c59a89973ef886cc280f0c68a572bf34";

export default node;
